export default __webpack_public_path__ + "static/Harmonization-5bb82b785e892b9713537fb11ab69e18.mp4";